var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTulUridesideview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.687,
    height: 743.518,
    viewBox: "0 0 282.687 743.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2,.cls-3{fill:none}.cls-1,.cls-2{stroke:#a1a0a0}.cls-1{stroke-linecap:round;stroke-linejoin:round}.cls-3{stroke:#000;stroke-width:3px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_side_view",
    "data-name": "TULU ride side view",
    transform: "translate(-3542.064 -3059.815)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(3550 3771.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233",
    "data-name": "Line 233",
    className: "cls-1",
    transform: "translate(.001 7.227)",
    d: "M90.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231",
    "data-name": "Line 231",
    className: "cls-2",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232",
    "data-name": "Line 232",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "rotate(180 1909.184 1892.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-2",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-2",
    "data-name": "Line 233",
    className: "cls-1",
    transform: "translate(.001 7.227)",
    d: "M95.868 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-2",
    "data-name": "Line 231",
    className: "cls-2",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-2",
    "data-name": "Line 232",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_433",
    "data-name": "Line 433",
    className: "cls-1",
    transform: "translate(3543.5 3709.667)",
    d: "M0 0v93.166"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_439",
    "data-name": "Line 439",
    className: "cls-3",
    transform: "translate(3678.31 3251.077)",
    d: "M126.768 0H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_436",
    "data-name": "Line 436",
    className: "cls-3",
    transform: "translate(3543.5 3700.833)",
    d: "M126.768 0H0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_437",
    "data-name": "Line 437",
    className: "cls-3",
    transform: "translate(3543.5 3248.833)",
    d: "M0 451.848 136.81 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_440",
    "data-name": "Line 440",
    className: "cls-3",
    transform: "translate(3670.269 3248.833)",
    d: "M0 451.848 136.81 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    className: "cls-3",
    d: "M6577-3273.865h146.6c10.092 0 6.025-8.033 0-9.708s-138.274-17.194-138.274-17.194z",
    transform: "translate(-2906.5 6974.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_124",
    "data-name": "Union 124",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.061 232.308 12.048-42.022L0 3.925 9.243 0l80.793 190.329-.559.237-12.763 44.512z",
    style: {
      stroke: "none"
    },
    transform: "translate(3591.033 3059.815)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.657 231.367 11.909-41.535L7.654 3.934l-3.72 1.58 78.352 184.578-11.514 40.16 3.885 1.115m2.057 3.711-9.653-2.77 12.048-42.021L0 3.925 9.243 0l80.793 190.329-.56.237-12.762 44.512z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(3591.033 3059.815)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line_438",
    "data-name": "Line 438",
    className: "cls-1",
    transform: "translate(3823.5 3709.667)",
    d: "M0 0v93.166"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulUridesideview);
export default __webpack_public_path__ + "static/media/TULU ride side view.f63f8f16707043b18ec2ad9bc6b01ae0.svg";
export { ForwardRef as ReactComponent };